import createSvgIcon from './createSvgIcon'

const VariantLight = createSvgIcon(
	<>
		<defs>
			<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="lightTheme-linearGradient-1">
				<stop stopColor="#999999" offset="0%"></stop>
				<stop stopColor="#F3F3F3" offset="100%"></stop>
			</linearGradient>
			<linearGradient x1="80.0223629%" y1="18.8799112%" x2="50%" y2="85.28%" id="lightTheme-linearGradient-2">
				<stop stopColor="#F9F9F9" offset="0%"></stop>
				<stop stopColor="#D6D6D6" offset="100%"></stop>
			</linearGradient>
			<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="lightTheme-linearGradient-3">
				<stop stopColor="#FFFFFF" offset="0%"></stop>
				<stop stopColor="#C6C6C6" offset="100%"></stop>
			</linearGradient>
			<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="lightTheme-linearGradient-4">
				<stop stopColor="#FFFFFF" offset="0%"></stop>
				<stop stopColor="#EDEDED" offset="100%"></stop>
			</linearGradient>
		</defs>
		<g id="Icons-playground" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Group-7">
				<rect id="Rectangle" fill="url(#lightTheme-linearGradient-1)" x="0" y="0" width="180" height="120"></rect>
				<path
					d="M56,36 L124,36 C132.836556,36 140,43.163444 140,52 L140,120 L140,120 L40,120 L40,52 C40,43.163444 47.163444,36 56,36 Z"
					id="Rectangle-Copy-36"
					fill="url(#lightTheme-linearGradient-2)"
				></path>
				<path
					d="M40,120 L40,52 C40,43.163444 47.163444,36 56,36 L124,36 C132.836556,36 140,43.163444 140,52 L140,120 L140,120"
					id="Path"
					stroke="url(#lightTheme-linearGradient-3)"
				></path>
				<path
					d="M55.5,99 L124.5,99 C128.918278,99 132.5,102.581722 132.5,107 L132.5,120 L132.5,120 L47.5,120 L47.5,107 C47.5,102.581722 51.081722,99 55.5,99 Z"
					id="Rectangle-Copy-37"
					fill="url(#lightTheme-linearGradient-4)"
				></path>
				<circle id="Oval" fill="#AAAAAA" cx="59.5" cy="56.5" r="10.5"></circle>
				<rect id="Rectangle" fill="#CFCBCB" x="49" y="74" width="61" height="7" rx="3.5"></rect>
				<rect id="Rectangle-Copy-38" fill="#CFCBCB" x="49" y="85" width="28" height="7" rx="3.5"></rect>
				<path
					d="M59,51 L59,50.5 C59,50.2238576 59.2238576,50 59.5,50 C59.7761424,50 60,50.2238576 60,50.5 L60,51 C60,51.2761424 59.7761424,51.5 59.5,51.5 C59.2238576,51.5 59,51.2761424 59,51 Z M59.5,52.5 C57.290861,52.5 55.5,54.290861 55.5,56.5 C55.5,58.709139 57.290861,60.5 59.5,60.5 C61.709139,60.5 63.5,58.709139 63.5,56.5 C63.4975888,54.2918605 61.7081395,52.5024112 59.5,52.5 Z M55.14625,52.85375 C55.3416207,53.0491207 55.6583793,53.0491207 55.85375,52.85375 C56.0491207,52.6583793 56.0491207,52.3416207 55.85375,52.14625 L55.35375,51.64625 C55.1583793,51.4508793 54.8416207,51.4508793 54.64625,51.64625 C54.4508793,51.8416207 54.4508793,52.1583793 54.64625,52.35375 L55.14625,52.85375 Z M55.14625,60.14625 L54.64625,60.64625 C54.4508793,60.8416207 54.4508793,61.1583793 54.64625,61.35375 C54.8416207,61.5491207 55.1583793,61.5491207 55.35375,61.35375 L55.85375,60.85375 C55.9801327,60.7273673 56.0294908,60.5431605 55.9832315,60.3705185 C55.9369722,60.1978765 55.8021235,60.0630278 55.6294815,60.0167685 C55.4568395,59.9705092 55.2726327,60.0198673 55.14625,60.14625 L55.14625,60.14625 Z M63.5,53.0000002 C63.6326481,53.0001043 63.7599014,52.9474943 63.85375,52.85375 L64.35375,52.35375 C64.5491207,52.1583793 64.5491207,51.8416207 64.35375,51.64625 C64.1583793,51.4508793 63.8416207,51.4508793 63.64625,51.64625 L63.14625,52.14625 C63.0030849,52.2892558 62.96023,52.5044538 63.0376888,52.6913951 C63.1151476,52.8783363 63.2976467,53.0001592 63.5,53.0000002 Z M63.85375,60.14625 C63.6583793,59.9508793 63.3416207,59.9508793 63.14625,60.14625 C62.9508793,60.3416207 62.9508793,60.6583793 63.14625,60.85375 L63.64625,61.35375 C63.7726327,61.4801327 63.9568395,61.5294908 64.1294815,61.4832315 C64.3021235,61.4369722 64.4369722,61.3021235 64.4832315,61.1294815 C64.5294908,60.9568395 64.4801327,60.7726327 64.35375,60.64625 L63.85375,60.14625 Z M54,56 L53.5,56 C53.2238576,56 53,56.2238576 53,56.5 C53,56.7761424 53.2238576,57 53.5,57 L54,57 C54.2761424,57 54.5,56.7761424 54.5,56.5 C54.5,56.2238576 54.2761424,56 54,56 Z M59.5,61.5 C59.2238576,61.5 59,61.7238576 59,62 L59,62.5 C59,62.7761424 59.2238576,63 59.5,63 C59.7761424,63 60,62.7761424 60,62.5 L60,62 C60,61.7238576 59.7761424,61.5 59.5,61.5 Z M65.5,56 L65,56 C64.7238576,56 64.5,56.2238576 64.5,56.5 C64.5,56.7761424 64.7238576,57 65,57 L65.5,57 C65.7761424,57 66,56.7761424 66,56.5 C66,56.2238576 65.7761424,56 65.5,56 Z"
					id="Shape"
					fill="#FFFFFF"
					fillRule="nonzero"
				></path>
			</g>
		</g>
	</>,
	{
		viewBox: '0 0 180 120',
	},
)

export default VariantLight
